import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./i18n/LanguageContext";
import GameBoard from "./components/GameBoard";
import SEOHead from "./components/SEOHead";

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <SEOHead />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<GameBoard />} />
          </Routes>
        </BrowserRouter>
      </div>
    </LanguageProvider>
  );
}

export default App;
